var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExternal = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2.75H2.75C2.05964 2.75 1.5 3.30964 1.5 4V10.25C1.5 10.9404 2.05964 11.5 2.75 11.5H9C9.69036 11.5 10.25 10.9404 10.25 10.25V7.75M7.75 1.5H11.5M11.5 1.5V5.25M11.5 1.5L5.25 7.75",
    stroke: "#FEFEFE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExternal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/external.17cbfc9c.svg";
export { ForwardRef as ReactComponent };